var lists_default = {
  "fontElementMap": "wuLbP",
  "orderedlist": "Zg8H6",
  "bulletedlist": "N1HsE",
  "listItem": "GxUq1"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
